import Layout from '../../components/layout/Layout';
import AdvantagesOfWithdrawal from './AdvantagesOfWithdrawal';
import { WithdrawCardInfo } from './WithdrawCardInfo';
import Faqs from '../../components/faq/Faq'
import { useWithdrawCard } from './hook/useWithdrawCard';
import WhyWithdraw from './WhyWithdraw';
import HowToDoIt from './HowToDoIt';

export const WithdrawCard = () => {
    const { faqs, getSubHeader, onGoToRegister } = useWithdrawCard();

    return (
        <Layout subHeader={getSubHeader()}>
            <WithdrawCardInfo />
            <AdvantagesOfWithdrawal onGoToRegister={onGoToRegister} />
            <WhyWithdraw />
            <HowToDoIt />

            <Faqs
                title={'Perguntas Frequentes'}
                faqs={faqs}
            />
        </Layout>
    );
}
